import styled, { TC } from '@benzinga/themetron';

export const DropDownStyled = styled(TC.DropdownMenu)`
  max-width: 250px;
  min-width: 185px;
  height: 100%;
  min-height: 30px;

  border-right: 1px solid ${props => props.theme.colors.borderDark};
`;

export const Toolbar = styled(TC.Row)`
  border: 1px solid ${props => props.theme.colors.borderDark};
  border-top: 0px;
`;
